import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NotificationPopover from "@Shared/components/general/notification-popover";
import InlineLoader from "@Shared/components/general/inline-loader";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ActionButtons",
  components: {
    NotificationPopover,
    InlineLoader
  },
  props: {
    status: {
      type: String,
      required: true
    },
    mppDocAvailable: {
      type: Boolean,
      required: true
    },
    mppAvailable: {
      type: Boolean,
      required: true
    },
    mppFailed: {
      type: Boolean,
      required: true
    },
    mppMessages: {
      type: Array,
      default: () => []
    },
    generatingMpp: {
      type: Boolean,
      default: false
    },
    mppDisabled: {
      type: Boolean,
      default: false
    },
    accessRights: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      acceptLoading: false,
      previewLoading: false,
      previewStatus: true
    };
  },
  computed: {
    loading() {
      return this.acceptLoading || this.previewLoading;
    },
    isPositiveStatus() {
      var _context;
      return _includesInstanceProperty(_context = ["accepted", "approved"]).call(_context, this.status);
    },
    acceptText() {
      return this.status === "accepted" ? this.$t("global.words.un-accept") : this.$t("global.words.accept");
    },
    mppMessagesToUse() {
      return this.mppMessages.length ? this.mppMessages : [{
        message: this.$t("direct-to-lender.lenderResponse.generatingMPP"),
        error: false
      }];
    },
    mppIsAvailableForDownload() {
      return this.mppAvailable && this.mppDocAvailable && !this.mppFailed;
    },
    allowSubmitApplication() {
      return !this.accessRights.submitApplications || this.accessRights.viewOnly;
    },
    disableAccept() {
      return this.accessRights.viewOnly;
    }
  },
  methods: {
    handleClick(event) {
      if (event === "accept") this.acceptLoading = true;
      if (event === "preview") this.previewLoading = true;
      this.$emit(event);
    },
    stopPreviewLoader(status) {
      this.previewStatus = status;
      this.previewLoading = false;
    },
    stopAcceptLoader() {
      this.acceptLoading = false;
    }
  }
});